import ICONS from '../static/media/icons/icons-helper';

export const MENU_BUTTONS = [
  { title: 'PEACEFUL PROTESTS', path: '/protests', icon: ICONS.WHITE_MARKER },
  { title: 'PRO-BONO LAWYERS', path: '/lawyers', icon: ICONS.MASK },
  { title: 'WHAT TO BRING', path: '/what-to-bring', icon: ICONS.DNI },
];

export const SOCIAL_BUTTONS = [
  {
    alt: 'Facebook',
    url: 'https://www.facebook.com/RocNation/',
    icon: ICONS.FB_ICON,
  },
  {
    alt: 'Instagram',
    url: 'https://www.instagram.com/rocnation/',
    icon: ICONS.IG_ICON,
  },
  { alt: 'Twitter', url: 'https://twitter.com/rocnation', icon: ICONS.TW_ICON },
  {
    alt: 'LinkedIn',
    url: 'https://www.linkedin.com/company/rocnation/',
    icon: ICONS.LIN_ICON,
  },
];

export const getCompleteMenuButtonsByMenuList = (menuList) => {
  const formatedMenuList =
    menuList.length > 0
      ? menuList.map((menuElem) => {
          return {
            title: menuElem.name,
            path: `/${menuElem.slug}`,
            icon: menuElem.icon,
          };
        })
      : [];

  const newButtons = [...formatedMenuList, ...MENU_BUTTONS];

  return newButtons;
};

export const sortMenuByPosition = (menuList = []) => {
  const list = menuList.sort((a, b) => a.position - b.position);
  return list;
};

export const getMenuNameBySlug = (menuList = [], slugToMatch = '') => {
  return slugToMatch && menuList.find(({ slug }) => slug === slugToMatch);
};
